import { AudioLayoutConfig } from '@features/Clip';
import { AudioTrack } from '@vidstack/react';
export interface FormatTrackNameParams {
    track: AudioTrack;
    index: number;
    allTracks: AudioTrack[];
    layout?: AudioLayoutConfig;
    isShort: boolean;
    getFallback: (id: string) => string;
}

export const getShortBaseName = (track: AudioTrack, fallback: string): string =>
    track.language?.toUpperCase().trim() || track.label?.trim() || fallback;

export const getFullBaseName = (
    track: AudioTrack,
    fallback: string,
): string => {
    const lang = track.language?.toUpperCase().trim() || '';
    const label = track.label?.trim() || '';

    if (!lang) return label || fallback;
    if (!label) return lang;
    return lang === label.toUpperCase() ? lang : `${lang} - ${label}`;
};

export const resolveTrackName = (
    track: AudioTrack,
    index: number,
    allTracks: AudioTrack[],
    nameExtractor: (t: AudioTrack, fb: string) => string,
    fallbackFn: (id: string) => string,
): string => {
    const baseName = nameExtractor(track, fallbackFn(track.id));
    const isDuplicate =
        allTracks.filter((t) => nameExtractor(t, fallbackFn(t.id)) === baseName)
            .length > 1;
    return isDuplicate ? `${baseName} #${index + 1}` : baseName;
};

export const formatCustomTrackName = ({
    track,
    index,
    allTracks,
    layout,
    isShort,
    getFallback,
}: FormatTrackNameParams): string => {
    if (layout) {
        const isIntl = layout.language.toUpperCase() === 'INTERNATIONAL';
        const langPrefix = isIntl
            ? isShort
                ? 'INTL'
                : 'INTERNATIONAL'
            : layout.language.substring(0, 2).toUpperCase();

        return `${langPrefix} - ${layout.mix}`;
    }

    return resolveTrackName(
        track,
        index,
        allTracks,
        isShort ? getShortBaseName : getFullBaseName,
        getFallback,
    );
};
